<script setup>
import {reactive, onMounted} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {ToastUtil} from "@/Utils/ToastUtil";

const data = reactive({
  headers: [
    { title: 'Claim #', key: 'claim' },
    { title: 'Client', key: 'client' },
    { title: 'Employee', key: 'employee' },
    { title: 'Age', key: 'age' },
    { title: 'Status', key: 'status' }
  ],
  items: []
});

onMounted(()=>{
  ApiWrapper.get('finance-issues', 'finance-issues')
  .then((response) => {
    if(response.financeIssues){
      data.items = response.financeIssues;
    }
  })
  .catch((err) => {
    ToastUtil.error(err);
  })
})
</script>

<template>
  <v-container fluid>
    <v-card class="elevation-2" height="auto" width="auto">
      <v-toolbar flat color="white">
        <v-toolbar-title>Financial Issues</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>
      <v-data-table :items="data.items" :headers="data.headers"></v-data-table>
    </v-card>
  </v-container>
</template>

<style scoped>
.container {
  padding: 5px;
}
[v-cloak] {
  display: none;
}
</style>